import {
  Close as CloseIcon,
  Explore as ExploreIcon,
  Info as InfoIcon,
  OpenInNew as OpenInNewIcon
} from "@mui/icons-material";
import {
  Box,
  IconButton,
  Tooltip,
  Typography
} from "@mui/material";

import CopyButton from "../../../components/CopyButton";

interface CoachingArtifactHeaderProps {
  markdownContent: string;
  onOpenMetadata: () => void;
  onExploreData: () => void;
  onPopOut?: () => void;
  onClose?: () => void;
  isDrawer?: boolean;
  showMetadataButton?: boolean;
}

const CoachingArtifactHeader = ({
  markdownContent,
  onOpenMetadata,
  onExploreData,
  onPopOut,
  onClose,
  isDrawer = false,
  showMetadataButton = false
}: CoachingArtifactHeaderProps) => {
  return (
    <Box sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      px: 3,
      py: 2,
      borderBottom: "1px solid",
      borderColor: "divider"
    }}>
      <Typography variant="h5" sx={{ fontWeight: 500 }}>
        Coaching Details
      </Typography>
      <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
        <CopyButton text={markdownContent} tooltipTitle="Copy" />
        {showMetadataButton && (
          <Tooltip title="View Configuration">
            <IconButton onClick={onOpenMetadata} size="small" color="primary">
              <InfoIcon />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip title="Explore Calls">
          <IconButton onClick={onExploreData} size="small" color="primary">
            <ExploreIcon />
          </IconButton>
        </Tooltip>
        {isDrawer && onPopOut && (
          <Tooltip title="Open in new tab">
            <IconButton onClick={onPopOut} size="small" color="primary">
              <OpenInNewIcon />
            </IconButton>
          </Tooltip>
        )}
        {onClose && (
          <Tooltip title="Close">
            <IconButton onClick={onClose} size="small" color="primary">
              <CloseIcon />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  );
};

export default CoachingArtifactHeader;
